import request from '@/utils/request'
import URL from './urlTranslator'

// 查询合作伙伴信息导入日志
export function queryImportRecord(params) {
  return request({
    url: URL.mdm.partnerInformationImport.queryImportRecord,
    method: 'get',
    params
  })
}

// 导入合作伙伴相关信息
export function importPartnerInformation(data) {
  return request({
    url: URL.mdm.partnerInformationImport.importPartnerInformation,
    method: 'post',
    data
  })
}

// 查询下载模板
export function downLoadTemplate(params) {
  return request({
    url: URL.mdm.partnerInformationImport.downLoadTemplate,
    method: 'get',
    params
  })
}
